import axios from 'axios'
import config from '@/config'
import { Toast } from 'vant'
// import { useStore } from 'vuex'

axios.defaults.baseURL = config.baseURL
axios.defaults.timeout = config.timeout
axios.defaults.withCredentials = true

axios.interceptors.request.use(
  config => {
    // Toast.loading({
    //   message: '加载中...',
    //   forbidClick: true,
    //   duration: 0,
    // })
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

axios.interceptors.response.use(
  response => {
    // Toast.clear()
    return Promise.resolve(response.data)
    if (response.data.code >= 0 || response.data.status == 200) {
      return Promise.resolve(response.data)
    } else {
      Toast({
        message: response.data.msg,
        position: 'bottom',
        className: 'toast-error',
      })
      return Promise.reject(response.data.msg)
    }
  },
  err => {
    Toast.clear()
    Toast({
      message: err,
      position: 'bottom',
      className: 'toast-error',
    })
    return Promise.reject(err)
  },
)

export default axios
